import {createLogger as createPowtoonLogger} from 'powtoon-commons/logger'
import uuid from 'powtoon-commons/utils/uuid'
import webvarsConfigurationService from '../services/webvarsConfigurationService'
import {isDev} from '../services/env'

const {getWebVar} = webvarsConfigurationService

const logzioId = getWebVar('logzioId')
const logzioMetricsId = getWebVar('logzioMetricsId')
const logzioUrl = getWebVar('logzioUrl')
const logLevel = getWebVar('min_log_level')
const appLevel = getWebVar('appLevel')
let userId = getWebVar('userId')

const data = {
  logzioId,
  logzioMetricsId,
  logzioUrl,
  appName: process.env.ENTRY_POINT_NAME,
  appVersion: process.env.BUILD_IDENTIFIER,
  appLevel: appLevel || 'n.a',
  userAgent: window.navigator.userAgent,
  tabId: uuid(),
  client_ip: getWebVar('clientIP'),
  
  get userId() {
    return userId || 'n.a'
  },
  set userId(value) {
    userId = value
  }
}

const logConfig = {
  logLocally: isDev,
  logRemotely: !!logzioId,
  logLevel
}

export const createLogger = ( loggerName = '') => {
  return createPowtoonLogger({moduleName: 'powtoon-producer-integration', loggerName}, data, logConfig)
}
